import { getUrlTriggerWebhookRead } from "~/views/trigger/utils/core";
import { TriggerFormData } from "~/stores/trigger-form.store";
import { config } from "~/config";
import { Broadcast, BroadcastVariables } from "~/entities/broadcast";
import { BroadcastDelay, WebhookDataT } from "~/views/trigger/types";
import { FileData } from "~/stores/broadcast.store";
import { broadcastVariablesMapToBroadcastVariables } from "~/views/trigger/utils/helpers";
import { HttpStatusCode } from "axios";
import { BaseCrudApi } from "./abstract/base-crud.api";
import { SetTriggerResponse } from "./messages/trigger/set-trigger.response";
import { TriggerListResponse } from "./messages/trigger/trigger-list.response";
import { WebhookDataResponse } from "./messages/trigger/webhook-data.response";

export type ResponseT<DataT> = { result: DataT }

export class setTriggerRequestParams {
	id: string | null;
	templateId: string | undefined;
	title: string | undefined;
	botId: string | undefined;
	variables: BroadcastVariables;
	delay: BroadcastDelay | null;
	templateFile: FileData | null;
	subscriptionId: string;
	fieldMap: Record<string, string>;
	createContact: boolean;
	active: boolean;

	static fromTriggerFormData(dto: TriggerFormData, subscriptionId: string): setTriggerRequestParams {
		return {
			id: dto.id,
			templateId: dto.templateId,
			title: dto.title,
			botId: dto.botId,
			delay: dto.delay,
			templateFile: dto.templateFile,
			fieldMap: dto.fieldMap,
			variables: broadcastVariablesMapToBroadcastVariables(dto.variables),
			subscriptionId,
			createContact: dto.createContact,
			active: dto.active
		}
	}
}

export type GetWebhookResponseT = WebhookDataT | null;


export class TriggerApi extends BaseCrudApi {
	getWebhook(triggerId: string): Promise<GetWebhookResponseT> {
		const url = getUrlTriggerWebhookRead(triggerId);
		return this.api.get<ResponseT<WebhookDataResponse>>(url).then((res) => {
			if (res.status === HttpStatusCode.Ok) {
				return res.data.result;
			}
			return null;
		})
	}
	setTrigger(params: setTriggerRequestParams): Promise<SetTriggerResponse> {
		return new Promise((resolve, reject) => {
			this.api.post<ResponseT<SetTriggerResponse>>(`${config.host}api/trigger`, params)
				.then((res) => resolve(res.data.result))
				.catch(err => reject(err));
		})
	}
	updateTrigger(id: string, params: Partial<setTriggerRequestParams>): Promise<SetTriggerResponse> {
		return new Promise((resolve, reject) => {
			this.api.patch<ResponseT<SetTriggerResponse>>(`${config.host}api/trigger/${id}`, params)
				.then((res) => resolve(res.data.result))
				.catch(err => reject(err));
		})
	}
	removeTrigger(id: string): Promise<void> {
		return new Promise((resolve, reject) => {
			this.api.delete<ResponseT<void>>(`${config.host}api/trigger/${id}`)
				.then((res) => {
					if (res.status !== 204) {
						reject(res.status)
					} else {
						resolve();
					}
				})
				.catch(err => reject(err));
		})
	}
	getList(): Promise<TriggerListResponse[]> {
		return this.api.get<ResponseT<TriggerListResponse[]>>(`${config.host}api/trigger/list`)
			.then((res) => res.data.result);
	}
}
